// eslint-disable-next-line no-shadow
enum Summer {
  Yes = 'Y',
  No = 'N',
}

export default Summer;
